import { useMemo } from 'react';
import { SMLRouteNames } from '../../../../routing/sml/SMLRoutes';
import { useSMLRoute } from '../../../../routing/sml/hooks';
import { currentScreenName, findNavGroupForScreen, SMLNavGroup } from '../smlNavigation';

export interface CurrentNavScreen {
  screen: SMLRouteNames | undefined;
  /** The group of the page on screen. `undefined` on Home, Settings and pages outside the groups. */
  group: SMLNavGroup | undefined;
}

/** The page on screen, and the navigation group it belongs to. */
export function useCurrentNavScreen(): CurrentNavScreen {
  const route = useSMLRoute();
  const screen = currentScreenName(route);
  return useMemo(() => ({ screen, group: findNavGroupForScreen(screen) }), [screen]);
}
